import { Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Table, TableBody, TableCell, TableContainer, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import { SwipeableListItem } from '@sandstreamdev/react-swipeable-list';
import React from 'react';
import Highlighter from "react-highlight-words";
import { FaMedium, FaTree } from "react-icons/fa";
import { GiNewspaper } from 'react-icons/gi';
import { connect } from 'react-redux';
import GenericBulten from 'src/components/GenericBulletin';
import axios from 'src/utils/axios';
import { setMaterialQuan, setMaterialSelection, setMaterialFilterKey } from '../../store/actions';
import BarkodPopup from '../BarcodePopup';
import ComplexSwipeContent from '../ComplexSwipeContent';
import EditMaterial from './edit';

const useStyles = makeStyles({
  tableContainer: {
    display: 'block',
    width: '100%',
    overflowX: 'auto',
    minHeight: 500,
  },
  table: {
    display: 'block',
    width: '100%',
    overflowX: 'auto',
  },
  tableCell: {
    maxWidth: 10,
  },
  tableCell1: {
    paddingLeft: 0,
    paddingRight: 2,
    maxWidth: 7,
  },
  checkboxCell: {
    width: 48,
    paddingLeft: 8,
    paddingRight: 8,
  },
});

const MaterialTable = (props) => {
  const classes = useStyles();
  const [openEdit, setOpenEdit] = React.useState(false);
  const [materialCode, setMaterialCode] = React.useState("");
  const [DebitCount, setDebitCount] = React.useState(0);
  const [materialDesc, setMaterialDesc] = React.useState("");
  const [UseMax, setUseMax] = React.useState(10);
  const [bultenOpen, setBultenOpen] = React.useState(false);
  const [bultenParam, setBultenParam] = React.useState('');
  const [muadilOpen, setMuadilOpen] = React.useState(false);
  const [muadilParam, setMuadilParam] = React.useState('');
  const [muadilTitle, setMuadilTitle] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");


  const selected = props.materials[props.defect] || [];
  let selectedAll = [];
  if (props.selectedDefects) {
    props.selectedDefects.forEach(d => {
      if (props.materials[d])
        selectedAll = [...selectedAll, ...props.materials[d]];
    });
  }
  const handleClick = (name, desc, Max, disabled,DebitCount) => {
    if (disabled) {
      return;
    }
    const selectedIndex = selected.indexOf(name);

    let newSelected = [];

    if (selectedIndex === -1) {
      // Add
      newSelected = [...selected, name];
      setOpenEdit(true);
      setMaterialCode(name);
      setMaterialDesc(desc);
      setDebitCount(DebitCount);
      setUseMax(parseInt(Max));
    } else {
      // Remove
      newSelected = [...selected.slice(0, selectedIndex)
        , ...selected.slice(selectedIndex + 1)
      ]
    }
    props.setMaterialFilterKey("");
    props.setMaterialSelection(props.defect, newSelected);
  };

  const handleBarkodClose = (barkod) => {
    props.setOpenBarkod(false);
    if (barkod.length === undefined) {
      return;
    }
    const row = props.materials?.materialsTable[barkod];
    if (row === undefined) {
      setUyari(barkod + " nolu malzeme bu ürün için tanımlı değildir!..");
      setOpen(true);
      return;
    }
    if (selected.indexOf(row.MaterialCode) === -1) {
      props.setMaterialSelection(props.defect, [...selected, row.MaterialCode]);
    }
    setOpenEdit(true);
    setMaterialCode(row.MaterialCode);
    setMaterialDesc(row?.MaterialDesc);
    setDebitCount(row.DebitCount);
    setUseMax(parseInt(row.UseQuantity));
  }

  const handleCloseEdit = (value) => {
    setOpenEdit(false);
    props.setMaterialQuan(materialCode, value);
  }

  const isSelected = (name) => (selected && selected.indexOf(name) !== -1);
  const isUsedBefore = (name) => (selectedAll && selectedAll.indexOf(name) !== -1);

  const highlight = (text) => {
    return <Highlighter
      searchWords={[props.materials.filterKey]}
      autoEscape={true}
      textToHighlight={text}
    />
  }

  const malzemeGoster = (materialCode) => {
    const data = {
      MALZEME_STOK_NO: materialCode,
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    let newWindow = window.open();
    if (!newWindow) {
      alert('Popup engelleyici aktif. Lütfen bu site için popup\'lara izin verin.');
      return;
    }
    axios.post('/FileImportExport/ArtemisMalzeme', data, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        newWindow.location = fileURL;
        newWindow.document.title = materialCode;
      })
  }

  const MuadilMalzemeGoster = (txt, malzeme) => {
    setMuadilParam(txt);
    setMuadilTitle(malzeme)
    setMuadilOpen(true);
  }

  const handleBultenOpen = (param) => {
    setBultenParam(param);
    setBultenOpen(true);
  }

  const getMaterialRow = (row, index) => {

    if (row === undefined) {
      return "";
    }


    const labelId = `enhanced-table-checkbox-${index}`;
    const isItemSelected = isSelected(row.MaterialCode);
    const isItemUsedBefore = isUsedBefore(row.MaterialCode);
    const disabled = isItemUsedBefore && !isItemSelected;
    return (
      <TableRow
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        selected={isItemSelected}
        key={row.MaterialCode}
      >
        <SwipeableListItem dense={true}
          swipeLeft={{
            content: (
              <ComplexSwipeContent
                icon={<FaMedium size={30} />}
                label="Muadil Malzeme"
                position="right"
                css="muadil"
              />
            ),
            action: () => MuadilMalzemeGoster(row.ActiveMuadil, row.MaterialCode)
          }}
          swipeRight={{
            content: (
              <ComplexSwipeContent
                icon={<GiNewspaper size={30} />}
                label="Malzeme Bülteni"
                position="left"
                css="bulten"
              />
            ),
            action: () => handleBultenOpen(row.MaterialCode)
          }}
          blockSwipe={props.readonly}
        >

          <TableCell className={classes.tableCell1}>
            <FaTree color='#FF9800' size='1.5em' visibility={parseInt(row.HistoricalBom) === 1 ? "show" : "hidden"} />
          </TableCell>
          <TableCell className={classes.tableCell}>
            <ImageSearchIcon
              onClick={() => malzemeGoster(row.MaterialCode)}
              color="primary">
            </ImageSearchIcon>
          </TableCell>
          <TableCell scope="row"
            onClick={() => handleClick(row.MaterialCode, row?.MaterialDesc, row.UseQuantity, disabled,row.DebitCount)}
          >
            <Grid container spacing={0}>
              <Grid style={{ color: row.SIP_VERILEBILIR ? 'inherit' : 'red' }} item xs={12}>
                <b>{highlight(row.MaterialCode)}</b>
                {" "}
                {highlight(row?.MaterialDesc)}
                <b>
                  <Chip size="small"
                    label={row?.PriceWithWat + " ₺"}
                  />
                  <Chip size="small"
                    label={'Ref:' + row?.Ref}
                  />
                  {row.ActiveMuadil.length > 0 && <Chip color="secondary" size="small"
                    label={'M'}
                  />}
                  {row.DebitCount > 0 && <b style={{ color: 'green' }}> Zimmet : {row.DebitCount}</b>}
                </b>
              </Grid>
            </Grid>
          </TableCell>
          <TableCell 
            className={classes.checkboxCell}
            onClick={() => handleClick(row.MaterialCode, row?.MaterialDesc, row.UseQuantity, disabled,row.DebitCount)}
          >
            <Checkbox
              checked={isItemSelected || isItemUsedBefore}
              inputProps={{ 'aria-labelledby': labelId }}
              color="primary"
              disabled={disabled}
            />
          </TableCell>
        </SwipeableListItem>
      </TableRow>
    )
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <EditMaterial
        open={openEdit}
        defect={props.defect}
        materialCode={materialCode}
        materialDesc={materialDesc}
        DebitCount={DebitCount}
        value={1}
        min={1}
        max={UseMax}
        onClose={handleCloseEdit}
      />
      <Dialog
        open={bultenOpen}
        onClose={() => setBultenOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          Malzemeye Ait Bültenler
        </DialogTitle>
        <DialogContent>
          <GenericBulten param={bultenParam} />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setBultenOpen(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen
        open={muadilOpen}
        onClose={() => setMuadilOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          {muadilTitle} Malzemenin Muadilleri
        </DialogTitle>
        <DialogContent>
          <TableContainer >
            <Table size="small" aria-label="material table">
              <TableBody className={classes.table}>
                {muadilParam.length === 0 ? 'Muadil Malzeme Bulunmuyor!...' : muadilParam.split(',').map((m, index) => {
                  let row = props.materials?.materialsTable[m];
                  return getMaterialRow(row, index);
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setMuadilOpen(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      <TableContainer >
        <Table size="small" aria-label="material table">
          <TableBody className={classes.table}>
            {(props.materials.filtered) && props.materials.filtered.sort(s => isUsedBefore(s.MaterialCode) ? -1 : 1).slice(0, props.GosterimAdet).map((row, index) => {
              return getMaterialRow(row, index);
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <BarkodPopup
        onClose={handleBarkodClose}
        open={props.openBarkod}
        ScanTime={0}
        CallScreen={0}
      />
    </>
  );
}


const mapStateToProps = (state) => ({
  materials: state.materialReducer,
  selectedDefects: state.defectReducer.selected,
});

const mapDispatchToProps = {
  setMaterialSelection: setMaterialSelection,
  setMaterialQuan: setMaterialQuan,
  setMaterialFilterKey: setMaterialFilterKey,
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialTable)
